import { Provider } from '@angular/core'

import { BOOKMARKS_FACADE } from '@ti/core/contracts/bookmarks'

export * from './bookmarks.manager'

import { BookmarksManager } from './bookmarks.manager'

export const provideBookmarksFacade = (): Provider[] => [
  { provide: BOOKMARKS_FACADE, useExisting: BookmarksManager },
]
